export default __webpack_public_path__ + "static/media/lock.765a528c.svg";